import { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import WebApp from '@twa-dev/sdk'

const ITINERARY_SHARE_RE = /^it_[A-Za-z0-9_-]{22}$/

export function getTelegramStartParam() {
  const fromTelegram = WebApp.initDataUnsafe?.start_param
  if (fromTelegram) return fromTelegram
  return new URLSearchParams(window.location.search).get('tgWebAppStartParam') || ''
}

export function TelegramLaunchRouter() {
  const location = useLocation()
  const navigate = useNavigate()
  const handledParamRef = useRef('')

  useEffect(() => {
    const startParam = getTelegramStartParam()
    if (!ITINERARY_SHARE_RE.test(startParam)) return
    if (handledParamRef.current === startParam) return
    handledParamRef.current = startParam
    const currentShare = new URLSearchParams(location.search).get('share')
    if (location.pathname === '/calendar' && currentShare === startParam) return
    navigate(`/calendar?planner=1&share=${encodeURIComponent(startParam)}`, { replace: true })
  }, [location.pathname, location.search, navigate])

  return null
}
